import React, { useContext, useEffect, useState } from 'react'
import AdminContext from '../../../StateContext/Application'
import { Form, Link } from 'react-router-dom'
import { Chart } from "react-google-charts";
import { usePDF } from 'react-to-pdf';
const MISActiveReport = () => {
  const content = useContext(AdminContext)
  const { MisReports } = content
  const [Display, SetDisplay] = useState('none')
  const [Displayrender, SetDisplayRender] = useState([])
  const [Data, SetData] = useState([])
  
  const [Register, SetRegisterations] = useState([])
  const { toPDF, targetRef } = usePDF({ filename: 'page.pdf' });
  useEffect(() => {
    try {
      GetData();
    } catch (error) {
      console.error('Error getting data:', error);
    }
  }, [])

  async function GetData(params) {
    try {
      let data = await MisReports();

      const dataArray = data.map(item => [
        item.Tender_Name+'\n'+item.Total_GstAmount / item.Total_Registrations+' per Gst'+'\n'+item.Total_EMD / item.Total_Registrations+' per EMD Fee'+'\n'+item.Total_TenderFee / item.Total_Registrations+' per Tender Fee',
        item.Total_GstAmount,
        item.Total_EMD,
        item.Total_TenderFee
      ]);
      console.log(dataArray);
      const BarRegisteration = data.map(item => [
        item.Tender_Name +'-'+item.Tender_ID+'\n'+item.Total_GstAmount / item.Total_Registrations+' per Gst'+'\n'+item.Total_EMD / item.Total_Registrations+' per EMD Fee'+'\n'+item.Total_TenderFee / item.Total_Registrations+' per Tender Fee',
        item.Total_Registrations,
      ]);

      // Insert header row
      dataArray.unshift(["Tender_Name", "Total_GstAmount", "Total_EMD", "Total_TenderFee"]);
      BarRegisteration.unshift(["Tender_Name", "Total_Registrations"]);

      SetData(dataArray);
      SetRegisterations(BarRegisteration);
    } catch (error) {
      console.error('Error processing data:', error);
    }
  }

  const options1 = {
    title: "Active Tenders Report Gst / Fee / Emd",
    chartArea: { width: "60%" },
    hAxis: {
      title: "Data",
      minValue: 0,
    },
    vAxis: {
      title: "Tenders",
    },
  };

  const options = {
    chart: {
      title: "Active Tenders Registerations"
    },
  };


  return (
    <>
      <div id='Auctions'>
        <nav className="navbar navbar-expand-lg bg-body-tertiary">
          <div className="container-fluid">
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>
          <button onClick={()=> toPDF()} className="mx-3 btn btn-danger">Download Pdf</button>
        </nav>
        <div style={{display:'grid',justifyContent:'center'}} ref={targetRef}>
          <Chart
            chartType="BarChart"
            width="80vw"
            height="50vh"
            data={Data}
            options={options1}
          />
          <hr/>
           <Chart
            chartType="Bar"
            width="80vw"
            height="400px"
            data={Register}
            options={options}
          />
        </div>
      </div>
    </>
  )
}

export default MISActiveReport



